import * as angular from 'angular';

// components
import sensorNameModalComponent from './sensorNameModal.component';

export default angular
    .module('fp:activationswizard:sensor:modals', [])
    .component('awSensorNameModal', sensorNameModalComponent);